import React from 'react'
import { useDispatch } from 'react-redux'

import { Actions } from 'store'

import {
  Wrapper,
  WrapperCustom,
  Body,
  Title,
  IconContainer,
  Description,
} from './styles'
import { BtnCardProps, BtnCardCustomProps } from './types'

const BtnCard = ({ icon, label, description, ...rest }: BtnCardProps) => {
  const dispatch = useDispatch()

  return (
    <Wrapper
      {...rest}
      onClick={() =>
        dispatch(Actions.component.spinnerChange({ remove: false, show: true }))
      }
    >
      <IconContainer>{icon}</IconContainer>
      <Body>
        <Title>{label}</Title>
        <Description>{description}</Description>
      </Body>
    </Wrapper>
  )
}

export const BtnCardCustom = ({
  icon,
  label,
  description,
  children,
  ...rest
}: BtnCardCustomProps) => (
  <WrapperCustom {...rest}>
    <IconContainer>{icon}</IconContainer>
    <Body>
      <Title>{label}</Title>
      <Description>{description}</Description>
      {children}
    </Body>
  </WrapperCustom>
)

export default BtnCard
